import { render, staticRenderFns } from "./Slide5.vue?vue&type=template&id=2ff5b365&scoped=true&"
import script from "./Slide5.vue?vue&type=script&lang=js&"
export * from "./Slide5.vue?vue&type=script&lang=js&"
import style0 from "./Slide5.vue?vue&type=style&index=0&id=2ff5b365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5b365",
  null
  
)

export default component.exports